import React, { createContext, useContext, useState, useEffect } from 'react';

// Create context
const UIContext = createContext();

// Custom hook to use the UI context
export const useUI = () => useContext(UIContext);

export const UIProvider = ({ children }) => {
  // State for mobile menu
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  // State for active section (for navigation highlighting)
  const [activeSection, setActiveSection] = useState('home');
  
  // State for scroll position
  const [scrollPosition, setScrollPosition] = useState(0);
  
  // Handle scroll events
  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  
  // Close mobile menu
  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };
  
  // Determine if header should be compact (after scrolling)
  const isHeaderCompact = scrollPosition > 50;
  
  return (
    <UIContext.Provider
      value={{
        mobileMenuOpen,
        toggleMobileMenu,
        closeMobileMenu,
        activeSection,
        setActiveSection,
        scrollPosition,
        isHeaderCompact
      }}
    >
      {children}
    </UIContext.Provider>
  );
};
